export default __webpack_public_path__ + "static/media/45t.8b524229.jpg";